import { HeroText } from '@/components/hero-text';

const content = [
    'Enjoy',
    <br key="br" />,
    'the',
    <span key="space2">&nbsp;</span>,
    'ride',
];

export const Heading = () => (
    <HeroText
        content={content}
        delayStartAnimation={0}
        delayBetweenChildrenAnimation={0.4}
        durationChildAnimation={0.3}
        className={`typography-hero-2`}
    />
);
